import PnlAccountList from './BankAccountList';
import BankAccountShow from './BankAccountShow';

export default {
  list: PnlAccountList,
  show: BankAccountShow,
};
